<!-- Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved. -->

<ng-container *ngrxLet="endpointsResponse$ as endpointsResponse">
    <div class="table-wrapper">
        <table mat-table [dataSource]="endpointsResponse?.devices" aria-label="Activation Information about endpoints activated against this subscription">
            <ng-container matColumnDef="computerName">
                <th mat-header-cell *matHeaderCellDef>{{'COMPUTER_NAME' | translate}}</th>
                <td mat-cell *matCellDef="let endpoint">
                    <a [routerLink]="['/device', endpoint.uuid]">{{endpoint.computer_name}}</a>
                </td>
            </ng-container>

            <ng-container matColumnDef="lastSeen">
                <th mat-header-cell *matHeaderCellDef>{{'D3ED_ACTIVATED' | translate}}</th>
                <td mat-cell *matCellDef="let endpoint">{{endpoint.created_dttm  | date}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        </table>
    </div>
    <mat-paginator class="device-paginator"
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[5, 25, 50, 100, 500, 1000]"
                   [pageIndex]="pageIndex"
                   [hidePageSize]="false"
                   [showFirstLastButtons]="true"
                   [length]="endpointsResponse?.total"
                   (page)="handlePageEvent($event)"></mat-paginator>
</ng-container>

